import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToTop } from '../utils/scrollToTop';

function ScrollToTop() {
  const { pathname } = useLocation();

  // Run before paint so the new route is shown from the top.
  useLayoutEffect(() => {
    scrollToTop();
  }, [pathname]);

  // Browsers may restore scroll position after navigation; override on the next frame too.
  useEffect(() => {
    scrollToTop();
    const frame = window.requestAnimationFrame(() => scrollToTop());
    return () => window.cancelAnimationFrame(frame);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
